export default __webpack_public_path__ + "static/media/b61.9933d920.png";